import React from "react";
import { Table } from "antd";

const BaseTable = ({ columns = [], datas = [], loading = true }) => (
  <Table
    columns={columns}
    dataSource={datas}
    loading={loading && datas.length === 0 ? true : false}
    rowKey="id"
    pagination={{ defaultPageSize: 50, pageSizeOptions: [50, 100] }}
  />
);

export { BaseTable };
